import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c435ec6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal_fone"
}
const _hoisted_2 = { class: "modal_window" }
const _hoisted_3 = {
  key: 0,
  class: "end_text win_text"
}
const _hoisted_4 = {
  key: 1,
  class: "end_text not_win_text"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "loser" }, "Вы прогирали!!!", -1))
const _hoisted_6 = { class: "loser" }


import {useStore} from 'vuex'
import {restartGame} from '../composables/RestartGame'

export default /*#__PURE__*/_defineComponent({
  __name: 'EndGameModal',
  props: {
    isLose: {
        type: Boolean,
        required: true,
        default: false
    },
    isWin: {
        type: Boolean,
        required: true,
        default: false
    }
},
  setup(__props) {

const store = useStore();




return (_ctx: any,_cache: any) => {
  return (__props.isLose || __props.isWin)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["wrapper_text_model_window", {'bg_win': __props.isWin, 'bg_lose': __props.isLose}])
          }, [
            (__props.isWin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Поздравляем, Вы победили!!! "))
              : (__props.isLose)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("p", _hoisted_6, [
                      _createTextVNode("Загаданное имя - "),
                      _createElementVNode("span", null, _toDisplayString(_unref(store).getters.getWord), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "restart_game",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(restartGame)()))
            }, "Сыграть еще раз")
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})